import ParameterErrors from '../errors/ParameterErrors';
import Validation from '../validation/Validation';
const{throwNotProvided, throwNotOfType}=ParameterErrors;
export default class DynamicImageEntry {
	constructor(props){
		const {relativePath, width, height} = props;
		this._width = width;
		this._height = height;
		this._relativePath = relativePath;
	}
	get width(){
		return this._width;
	}
	get height(){
		return this._height;
	}
	get relativePath(){
		return this._relativePath;
	}
	static fromJSON(jObject){
		return new DynamicImageEntry({
			width:jObject.width,
			height:jObject.height,
			relativePath:jObject.relativePath
		});
	}
}